import { IRestaurant } from "../models/IRestaurant";
import { S3_IMAGE_BASE_URL } from "../config/restaurantConfig";

interface Props {
  restaurant: IRestaurant | null;
}

export default function About({ restaurant }: Props) {
  const image = restaurant?.restourantFeatureadImagePath
    ? S3_IMAGE_BASE_URL + restaurant.restourantFeatureadImagePath
    : restaurant?.restourantLogoPath
    ? S3_IMAGE_BASE_URL + restaurant.restourantLogoPath
    : undefined;

  return (
    <section id="hakkimizda" className="rr-section">
      <div className="rr-section-title">
        <span>Hakkımızda</span>
        <h2>{restaurant?.restourantName ?? "Restoran"}</h2>
      </div>
      <div className="rr-about-grid">
        {image && <img src={image} alt={restaurant?.restourantName} className="rr-about-image" />}
        <div className="rr-about-info">
          {restaurant?.restourantAddress && (
            <div className="rr-info-row">
              <i className="bi bi-geo-alt-fill"></i>
              <div>
                <div className="rr-info-row-label">Adres</div>
                <div className="rr-info-row-value">{restaurant.restourantAddress}</div>
              </div>
            </div>
          )}
          {restaurant?.restourantPhoneNo && (
            <div className="rr-info-row">
              <i className="bi bi-telephone-fill"></i>
              <div>
                <div className="rr-info-row-label">Telefon</div>
                <div className="rr-info-row-value">{restaurant.restourantPhoneNo}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
